/**
 * Davetten gelen kullanıcının hesap adımından SONRA döneceği yol (CLOS-74 `[035]`).
 *
 * Kart, kapsamına "mevcut veya yeni hesapla eşleştirme ... ve sonuç yönlendirmesi"ni
 * açıkça alıyor. Dönüş yolu olmasaydı davetli, giriş ya da kayıt biter bitmez `/tenants`'a
 * düşer ve davetini kaybederdi; elindeki tek çare e-postaya dönüp bağlantıya yeniden
 * tıklamak olurdu.
 *
 * ### Neden serbest bir `returnTo` değil
 *
 * Hedef adres dışarıdan ALINMIYOR, yalnız token alınıyor ve yol burada `/davet` olarak
 * SABİT üretiliyor. Genel bir `?returnTo=<url>` parametresi açık yönlendirme (open
 * redirect) yüzeyi olurdu: saldırgan giriş bağlantısını kendi sitesine dönecek biçimde
 * hazırlayıp kullanıcıyı taşıyabilirdi. Buradaki biçimde taşınabilecek tek şey token'dır.
 *
 * Token'ın adres çubuğunda görünmesi yeni bir sızıntı açmıyor: kullanıcı zaten onu adres
 * çubuğunda taşıyan bir e-posta bağlantısıyla geldi.
 */
export function inviteReturnPath(search: string): string | null {
  const params = new URLSearchParams(search);
  const token = params.get("davet");
  if (token) return `/davet?token=${encodeURIComponent(token)}`;
  /**
   * Haricî katılımcı daveti (CLOS-147 `[128]`) — aynı sabit-yol kuralıyla ikinci hedef:
   * taşınabilen tek şey yine token, yol burada üretiliyor (open redirect yüzeyi yok).
   */
  const katilimci = params.get("katilimci");
  if (katilimci) return `/katilimci-davet?token=${encodeURIComponent(katilimci)}`;
  /** Müvekkil Temsilcisi daveti (CLOS-177 `[124]`) — üçüncü sabit hedef, aynı kural. */
  const temsilci = params.get("temsilci");
  if (temsilci) return `/temsilci-davet?token=${encodeURIComponent(temsilci)}`;
  /**
   * Sözleşme tarafı daveti (CLOS-1132 · Halit kararı 2) — dördüncü sabit hedef. Sayfa
   * daveti gösterir; karar Davetlerim'de verilir.
   */
  const sozlesme = params.get("sozlesme");
  if (sozlesme) return `/sozlesme-davet?token=${encodeURIComponent(sozlesme)}`;
  /**
   * Token'sız davetler (hukuk bürosunun hizmet daveti, CLOS-1133): e-posta bağlantısı
   * giriş/kayıt sonrası doğrudan Davetlerim'e döner. Değer kapalı bir sözcük — serbest bir
   * yol değil; allowlist'te olmayan her şey `null`.
   */
  if (params.get("hedef") === "davetlerim") return "/davetlerim";
  return null;
}
